import { render, staticRenderFns } from "./ActivityNotice.vue?vue&type=template&id=d2406158&scoped=true&"
import script from "./ActivityNotice.vue?vue&type=script&lang=js&"
export * from "./ActivityNotice.vue?vue&type=script&lang=js&"
import style0 from "./ActivityNotice.vue?vue&type=style&index=0&id=d2406158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2406158",
  null
  
)

export default component.exports